module.exports = __webpack_public_path__ + "static/_KOG7261_optimized-439e086156b6648a79bd1ca4b42dfd7c.jpg";